// React
import { ReactElement } from 'react';
// Context
import { QualifiersProvider } from '@utmb/contexts/QualifiersContext';
// Features
import { QualifiersFilters } from '@utmb/features/qualifiers/qualifers-filters/QualifiersFilters';
import { QualifiersList } from '@utmb/features/qualifiers//QualifiersList';

export const QualifiersContainer = ({ races = [], filters }: any): ReactElement => {
    return (
        <div className={`container px-0 py-5`}>
            <QualifiersProvider result={races} filters={filters}>
                <QualifiersFilters />
                <QualifiersList />
            </QualifiersProvider>
        </div>
    );
};
